/* eslint-disable */
// 定义设置axios 请求实例
import axios from 'axios'
// 导入封装的message
import {
  message
} from '@/utils/message.js'
// 导入vuex store
import store from '@/store'
// 导入token处理
import {
  getToken,
  removeToken,
  removeUserName
} from '@/utils/auth'

import router from '@/router'

// 设置允许跨域访问
axios.defaults.withCredentials = true
// 创建axios实例
const instance = axios.create({
  baseURL: '',
  timeout: 60000
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 让每个请求携带token
    config.headers['Authorization'] = getToken()
    config.headers['Access-Control-Allow-Origin'] = '*'
    // 改为加载中状态
    store.commit('SHOW_LOADING')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器
instance.interceptors.response.use(
  function (response) {
    console.log('成功', response)
    // 取消加载中状态
    store.commit('HIDE_LOADING')
    // 有的接口封装了，有的没封装，封装的接口response.data.code为200，未封装的接口，response.data就是数据了
    if (response.data.code === 200) {
      return response.data
    }else if(response.errcode === 0) {
      // 钉钉发送消息
      return response
    }else if (!response.data.code) {
      // 接口未封装
      return response
    } else {
      // 错误信息提示
      message.error(response.data.msg || '请求错误')
      // 抛出异常
      return Promise.reject(response.data)
    }
  },
  function (error) {
    // 取消加载中状态
    store.commit('HIDE_LOADING')
    console.log('失败', error)
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message.error('请求参数异常')
          break
        case 401:
          message.error('登录已过期')
          removeToken()
          removeUserName()
          router.push('/admin/login')
          store.commit('LOGIN_STATE_FALSE')
          break
        case 403:
          message.error('无访问权限，请联系企业管理员')
          break
        default:
          message.error(error.response.data.message || '服务端异常，请联系技术支持')
      }
    } else {
      message.error('出现错误')
      removeToken()
      removeUserName()
      // router.push('/admin/login')
    }
    return Promise.reject(error)
  })

export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js